<template>
  <div>
    <h3 class="mb-2 text-center">Términos de privacidad</h3>
    <div class="terminos-box p-3 bg-white rounded shadow-sm">
      <p>Al registrar a un asistente aceptas:</p>
      <ul>
        <li>🛡️ Usamos los datos solo para validar el acceso al evento.</li>
        <li>🧼 Las fotos se eliminan 12 horas después del evento.</li>
        <li>☁️ Los datos están cifrados y seguros en AWS.</li>
        <li>🔒 No compartimos tu información. Tu privacidad es prioridad.</li>
      </ul>
      <p class="mt-3 text-center">
        👶 Si el asistente es menor, debe subir una imagen por seguridad.
      </p>
      <p class="mt-3 text-center">
        🚫 Si la imagen no coincide con quien se presenta, se podrá negar la entrada al
        evento.
      </p>
      <p class="mt-3 text-center">
        📩 Dudas:
        <a href="mailto:evolvegrapplingpro@coudera.com">
          evolvegrapplingpro@coudera.com
        </a>
      </p>
    </div>
  </div>
</template>

<style scoped>
.terminos-box {
  max-width: 100%;
  margin: 0 auto;
  line-height: 1.6;
  padding: 0.5rem 0;
  background: #fff;
  border-radius: 1rem;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.08);
}

/* UL y LI más estilizados */
.terminos-box ul {
  padding-left: 1.2rem;
  margin-bottom: 1rem;
}

.terminos-box li {
  margin-bottom: 0.8rem;
  display: flex;
  align-items: start;
  gap: 0.5rem;
  font-size: 0.95rem;
  word-break: break-word;
}

/* Íconos más pequeños si lo deseas */
.terminos-box li::marker {
  content: none;
}

/* Responsive */
@media (max-width: 576px) {
  .terminos-box {
    padding: 1rem;
    font-size: 0.85rem;
  }

  .terminos-box li {
    font-size: 0.85rem;
    gap: 0.4rem;
  }

  .terminos-box a {
    font-size: 0.85rem;
    word-break: break-word;
  }
}
</style>
